import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import './App.css';
import VaultStats from './components/VaultStats';
import DepositForm from './components/DepositForm';
import WithdrawForm from './components/WithdrawForm';
import { CONTRACTS, CHAIN_ID } from './contracts/addresses';

function App() {
  const [account, setAccount] = useState(null);
  const [provider, setProvider] = useState(null);
  const [signer, setSigner] = useState(null);
  const [chainId, setChainId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  
  const connectWallet = async () => {
    if (typeof window.ethereum === 'undefined') {
      alert('Please install MetaMask');
      return;
    }

    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();
      const address = await signer.getAddress();
      const network = await provider.getNetwork();
      
      setProvider(provider);
      setSigner(signer);
      setAccount(address);
      setChainId(network.chainId);
      
      if (network.chainId !== CHAIN_ID) {
        alert('Please switch to Sepolia testnet');
      }
    } catch (error) {
      console.error('Error connecting wallet:', error);
    }
  };

  const disconnectWallet = () => {
    setAccount(null);
    setProvider(null);
    setSigner(null);
    setChainId(null);
  };

  const handleTransactionSuccess = () => {
    setRefreshKey(prev => prev + 1);
  };

  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', (accounts) => {
        if (accounts.length > 0) {
          connectWallet();
        } else {
          disconnectWallet();
        }
      });

      window.ethereum.on('chainChanged', () => {
        window.location.reload();
      });
    }
  }, []);

  const formatAddress = (addr) => {
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  return (
    <div className="App">
      <header className="header">
        <div className="header-content">
          <div className="logo">
            <div className="logo-text">LiquidVault</div>
            <div className="logo-subtitle">USDC Yield Optimizer</div>
          </div>
          
          {!account ? (
            <button className="connect-btn" onClick={connectWallet}>
              Connect Wallet
            </button>
          ) : (
            <div className="wallet-info">
              <span className="address">{formatAddress(account)}</span>
              {chainId === CHAIN_ID && <span className="network">Sepolia</span>}
              <button className="disconnect-btn" onClick={disconnectWallet}>
                Disconnect
              </button>
            </div>
          )}
        </div>
      </header>

      <main className="container">
        {chainId && chainId !== CHAIN_ID && (
          <div className="warning">
            Wrong network. Please switch to Sepolia testnet.
          </div>
        )}

        {account && chainId === CHAIN_ID ? (
          <>
            <VaultStats 
              provider={provider} 
              account={account}
              refreshKey={refreshKey}
            />
            
            <div className="actions">
              <DepositForm 
                signer={signer} 
                account={account}
                provider={provider}
                onSuccess={handleTransactionSuccess}
              />
              <WithdrawForm 
                signer={signer} 
                account={account}
                provider={provider}
                onSuccess={handleTransactionSuccess}
              />
            </div>

            <div className="footer-info">
              <a 
                href={`https://sepolia.etherscan.io/address/${CONTRACTS.vault}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Contract on Etherscan
              </a>
              <span className="divider">|</span>
              <a 
                href={`https://sepolia.etherscan.io/address/${account}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Your Transactions
              </a>
            </div>
          </>
        ) : !account ? (
          <div className="empty">
            <h2>Connect Your Wallet</h2>
            <p>Connect to start earning yield on your USDC</p>
          </div>
        ) : null}
      </main>
    </div>
  );
}

export default App;